/**
 * Reusable notification service that wraps the `send-notification` Supabase edge function.
 * Fire-and-forget: logs warnings on failure but never throws.
 */

interface NotificationParams {
  event_type: string;
  priority: 'high' | 'normal' | 'low';
  title: string;
  summary: string;
  data: Record<string, unknown>;
}

export async function sendNotification(
  params: NotificationParams
): Promise<void> {
  try {
    const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
    const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

    if (!supabaseUrl || !supabaseKey) {
      console.warn(
        '[notificationService] Missing Supabase credentials, skipping notification'
      );
      return;
    }

    const response = await fetch(
      `${supabaseUrl}/functions/v1/send-notification`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${supabaseKey}`,
        },
        body: JSON.stringify(params),
      }
    );

    if (!response.ok) {
      throw new Error(
        `Edge Function returned ${response.status}: ${await response.text()}`
      );
    }

    console.log(`[notificationService] Notification sent: ${params.title}`);
  } catch (error) {
    console.warn('[notificationService] Failed to send notification:', error);
  }
}
